<script lang="ts" setup>
import { type ILanguage, languagesMap } from '@/data/languages';

const props = withDefaults(
  defineProps<{
    showActive?: boolean;
  }>(),
  {
    showActive: false,
  },
);

const { currentLocale } = useLocales();

const route = useRoute();

const availableLanguages = computed<ILanguage[]>(() => {
  const langList = Object.values(languagesMap);

  if (props.showActive) {
    return langList;
  }

  return langList.filter((lang) => lang.value !== currentLocale);
});

const currentUrl = computed<string>(() => {
  if (route.params.lang) {
    return route.fullPath.replace(`/${route.params.lang}`, '');
  }

  return route.fullPath;
});
</script>

<template>
  <ul class="languages-list text-body-s text-weight-medium">
    <li
      v-for="lang in availableLanguages"
      :key="lang.value"
      class="languages-list__item"
    >
      <a
        class="languages-list__link"
        :href="`/${lang.value}${currentUrl}`"
      >
        <img
          :src="lang.iconLink"
          :alt="lang.label"
          width="16"
          height="16"
          loading="lazy"
        />

        {{ lang.label }}

        <svg
          v-if="currentLocale === lang.value"
          class="languages-list__check"
          width="24"
          height="24"
        >
          <use xlink:href="@/assets/images/svg/sprite-base.svg#check-24"></use>
        </svg>
      </a>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.languages-list {
  $this: 'languages-list';

  @include hide-scroll;
  @include reset-list;

  &__item {
    &:not(:last-child) {
      border-bottom: 1px solid $color-dark-blue-200;
    }

    @media (hover: hover) {
      &:hover {
        background-color: $color-secondary-800;

        .#{$this}__link {
          color: $color-white;
        }

        .#{$this}__check {
          color: $color-white;
        }
      }
    }
  }

  &__link {
    @include reset-link;

    height: 50px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    column-gap: 8px;
  }

  &__check {
    color: $color-secondary-800;
    margin-left: auto;
  }
}
</style>
